// libs/utils/useMetadataParser.ts
import { TypeProgram_metaWithoutUnresolvableLinksResponse } from '@2u-landing-pages/types';
import { useMemo } from 'react';
import { parseMetaTemplate } from './parseProgramMeta';

export const useMetadataParser = (
  metadata: TypeProgram_metaWithoutUnresolvableLinksResponse,
) => {
  const parseMetadata = useMemo(() => {
    return (template: string): string => parseMetaTemplate(template, metadata);
  }, [metadata]);

  // Get all fields from metadata directly
  const fields = useMemo(() => {
    return {
      ...metadata?.fields || {},
    };
  }, [metadata]);

  return {
    parseMetadata,
    fields
  };
};
